import { lazy } from "react"





export default [
    {
        path:"/manajemen-laporan/:param",
        component:lazy(()=>import("../../views/manajemen-lap/ManajemenLaporan"))
    }
]